import { useState, useEffect, useRef } from "react";
import {
  useAuthErrorMessage,
  useAuthSuccessMessage,
  webAuth
} from "../utils/userJourneyHelper";

import styles from "./ForgotPassword.module.css";
import { useRecaptcha } from "../hooks/useRecaptcha";

function ForgotPassword() {
  const { verifyHuman, challengeVisible, challengeError, challengeRef } =
    useRecaptcha("password_reset");
  const [formData, setFormData] = useState({
    email: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useAuthErrorMessage();
  const [successMessage, setSuccessMessage] = useAuthSuccessMessage();

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage();
    setError();

    const { ok, error: verifyError } = await verifyHuman();

    if (!ok) {
      setError(verifyError);
      setLoading(false);
      return;
    }

    setLoading(true);

    webAuth.changePassword({
      connection: 'Username-Password-Authentication',
      email: formData.email
    }, function (err, resp) {
      setLoading(false)
      if(err){
        setError(err.message)
      }else{
        setSuccessMessage(resp)
      }
    })
  };

  useEffect(() => {
    if (challengeVisible) {
      setLoading(false);
    }
  }, [challengeVisible]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const el = useRef(null);

  useEffect(() => {
    if (error && el.current) {
      el.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [error]);

  return (
    <div className={styles.auth}>
      <span className={styles.heroImageWrapper}>
        <span className={styles.heroImageSizer}>
          <img
            alt=""
            aria-hidden="true"
            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%271440%27%20height=%27899%27/%3e"
            className={styles.heroImageSpacer}
          />
        </span>
        <img
          alt=""
          srcSet="https://cdn.irishfunds.ie/1440x1800/8698c5e81d/bg-auth-image.jpeg/m/1440x0/filters:quality(80)?_w=1440 1x, https://cdn.irishfunds.ie/1440x1800/8698c5e81d/bg-auth-image.jpeg/m/1440x0/filters:quality(80)?_w=1440 2x"
          src="https://cdn.irishfunds.ie/1440x1800/8698c5e81d/bg-auth-image.jpeg/m/1440x0/filters:quality(80)?_w=1440"
          decoding="async"
          className={styles.heroImage}
        />
      </span>
      <section className={`${styles.auth_section} ${styles.forgotpassword} ${loading && styles.loading}`}>
        <div className={styles.header}>
          <svg
            role="presentation"
            viewBox="0 0 644 228"
            preserveAspectRatio="none"
            className={styles.shape}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.01758 -290.458L1006.94 473.78L1124.9 210.611L7.01758 -290.458Z"
              fill="#009247"
            ></path>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1125.6 209.059L-110.246 -28.8413L7.71373 -292.01L1125.6 209.059Z"
              fill="#3FAE48"
            ></path>
          </svg>
          <div className={styles.logo}>
            <span className={styles.logoWrapper}>
              <img
                alt=""
                aria-hidden="true"
                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2772%27%20height=%2734%27/%3e"
                className={styles.logoSpacer}
              />
            </span>
            <img
              alt="Irish Funds Logo"
              srcSet="/assets/img/IFlogo-white-small.png?_w=72 1x, /assets/img/IFlogo-white-small.png?_w=72 2x"
              src="/assets/img/IFlogo-white-small.png?_w=72"
              decoding="async"
              className={styles.logoImage}
            />
          </div>
        </div>
        <form className={styles.forgotpasswordForm} ref={el} onSubmit={submitHandler}>
          <h1 className={styles.heading}>Reset Password</h1>
          <p className={styles.description}>
            Enter your email address below to receive an email with instructions
            on how to reset your password.
          </p>
          {error && <p className={styles.error}>Error: {error}</p>}
          {successMessage && <p className={styles.success}>{successMessage}</p>}
          <div className={styles.fields}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              required
              placeholder="Email"
              onChange={handleChange}
            />
            <div className={styles.recaptcha} hidden={!challengeVisible}>
                <p className={styles.recaptchaHint}>
                  Please confirm you are not a robot to continue.
                </p>
                {challengeError && <p className={styles.error}>{challengeError}</p>}
                <div ref={challengeRef} />
              </div>
            <button
              type="submit"
              disabled={loading || challengeVisible}
              className={`${styles.forgotButton} ${styles.forgotButton_secondary}`}
            >
              Reset Password
            </button>
            <p className={styles.back}>
              <a href="/Auth/Login/">Back to login</a>
            </p>
          </div>
        </form>
      </section>
    </div>
  );
}

export default ForgotPassword;
